import { render, staticRenderFns } from "./StyleEditTabTrims.vue?vue&type=template&id=0bf3012b&"
import script from "./StyleEditTabTrims.vue?vue&type=script&lang=js&"
export * from "./StyleEditTabTrims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports